import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { downloadItem } from 'reactApp/appHelpers/appHelpers';
import { isArchive, isPreviewable } from 'reactApp/modules/file/utils';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { CloudItem } from 'reactApp/modules/storage/storage.types';
import { MobileViewerItem } from 'reactApp/ui/Mobile/MobileViewer/MobileViewerItem/MobileViewerItem';
import { ViewerArchiveConnected } from 'reactApp/ui/ReactViewer/ViewerArchive/ViewerArchive';
import { sendXray } from 'reactApp/utils/ga';

import styles from './PublicFile.css';

interface IProps {
    file: CloudItem;
}

export const PublicFile = memo<IProps>(({ file }) => {
    const isPreviewableFile = isPreviewable(file);
    const storage = useSelector(getCurrentStorage);

    const handleDownload = useCallback(() => {
        downloadItem({ itemOrId: file, fromViewer: true });
    }, [file]);

    const content = useMemo(() => {
        if (isArchive(file) && isPreviewableFile) {
            // FIXME: Тут нужно будет сделать отдельный компонент для мобильного просмотра архивов когда будут дизайны.
            return (
                <ViewerArchiveConnected
                    file={file}
                    storage={storage}
                    sendGa={(action, label) => sendXray(['indpnewv-public', action, label])}
                    isPhone={true}
                    embedded={true}
                />
            );
        }
        return <MobileViewerItem itemId={file.id} isSingle={true} handleDownload={handleDownload} />;
    }, [handleDownload, file, isPreviewableFile]);

    return (
        <div className={styles.root}>
            <div className={styles.content}>{content}</div>
        </div>
    );
});

PublicFile.displayName = 'PublicFile';
